import { ApiLottoUploadCsvPostRequest } from '@desio/api';
import Loader from 'components/loader';
import { dateWithTime } from 'helpers/utils';
import moment from 'moment';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { loader } from 'store/selectors';
import Text from '../../../../components/text';
import { addLotto, resetLottoCaricatoAction, setDataFine, setDataInizio } from './_redux/actions';
import { dataFine, dataInizio, lottoCaricatoSelector } from './_redux/selectors';


const contentType = 'text/csv';

const NuovaCampagna: React.FC = () => {

  const [nomeCampagna, setNomeCampagna] = useState("");
  const [fileCampagna, setFileCampagna] = useState<File | undefined>();
  const from = useAppSelector(dataInizio);
  const to = useAppSelector(dataFine);
  const toRef = React.useRef<DayPickerInput>();
  const loaderUploadActive = useAppSelector(loader('upload-file'));
  const lottoCaricato = useAppSelector(lottoCaricatoSelector);
  const inputFileRef = useRef<HTMLInputElement>(null);

  const history = useHistory();
  const dispatch = useAppDispatch();

  function handleFromChange(day: Date) {
    dispatch(setDataInizio(day))
  }

  function handleToChange(to: Date) {
    dispatch(setDataFine(to));
    showFromMonth();
  }

  /* calendar */

  function showFromMonth() {
    if (!from) {
      return;
    }
    if (to && moment(to).diff(moment(from), 'months') < 2) {
      toRef.current?.getDayPicker().showMonth(from);
    }
  }

  const addCampagna = async () => {
    if (fileCampagna) {
      let csvFile = new Blob([fileCampagna], { type: contentType });
      let fileAsString = await csvFile.text();
      let requestBody: ApiLottoUploadCsvPostRequest = {
        lottoCsvDto: {
          name: nomeCampagna,
          file: btoa(fileAsString),
          dataInizioCampagna: dateWithTime(from, "start"),
          dataFineCampagna: dateWithTime(to, "end")
        }
      }
      dispatch(addLotto(requestBody));
    }
  }

  useEffect(() => {
    if (lottoCaricato) {
      // reset lotto caricato
      dispatch(resetLottoCaricatoAction());
      // reset form
      if (inputFileRef?.current) {
        inputFileRef.current.value = "";
      }
      setNomeCampagna("");
      setFileCampagna(undefined);
    }
    !!lottoCaricato?.id && history.push(`/admin/campagne/${lottoCaricato.id}`);
  }, [lottoCaricato]);


  const modifiers = { start: from, end: to };
  return (
    <div>
      <Row>
        <Col md={9}>
          <Text title="Carica il csv con l'elenco degli NDG. E' possibile utilizzare il file di prova per inserire gli NDG."></Text>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col md={12}>
          <a className="p-0" href="/files/CSV_Esempio.csv" target="_blank" download="CSV_Esempio.csv"><i className="fas fa-download"></i>DOWNLOAD CSV DI PROVA</a>
        </Col>
      </Row>

      <Row className="InputFromTo mb-3 mt-3">
        <Col md={3} className="InputFromTo-to">
          <Text title="Data inizio" />
          <DayPickerInput
            value={from}
            placeholder="Data inizio"
            format="LL"
            formatDate={MomentLocaleUtils.formatDate}
            parseDate={MomentLocaleUtils.parseDate}
            inputProps={{ className: 'form-control' }}
            dayPickerProps={{
              locale: 'it',
              localeUtils: MomentLocaleUtils,
              selectedDays: [from, { from, to }],
              disabledDays: { before: new Date(), after: to },
              toMonth: to,
              modifiers,
              numberOfMonths: 2,
              onDayClick: () => toRef.current?.getInput().focus(),
            }}
            onDayChange={handleFromChange}
          />
        </Col>
        <Col md={3} className="InputFromTo-to">
          <Text title="Data fine" />
          <DayPickerInput
            ref={(ref: any) => toRef.current = ref}
            value={to}
            placeholder="Data fine"
            format="LL"
            formatDate={MomentLocaleUtils.formatDate}
            parseDate={MomentLocaleUtils.parseDate}
            inputProps={{ className: 'form-control' }}
            dayPickerProps={{
              locale: 'it',
              localeUtils: MomentLocaleUtils,
              selectedDays: [from, { from, to }],
              disabledDays: { before: from },
              modifiers,
              month: from,
              fromMonth: from,
              numberOfMonths: 2,
            }}
            onDayChange={handleToChange}
          />
        </Col>
        <Col md={3}>
          <Text title="&nbsp;"></Text>
          <Form>
            <Form.File
              ref={inputFileRef}
              label={fileCampagna ? fileCampagna.name : "Carica il CSV"}
              custom
              accept={contentType}
              disabled={loaderUploadActive}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFileCampagna(e.target.files?.[0])}
            />

          </Form>
        </Col>
        <Col md={3}>
          <Text title="&nbsp;"></Text>
          <Form.Group controlId="formBasicEmail">
            <Form.Control type="text" value={nomeCampagna} required disabled={!fileCampagna || loaderUploadActive} onChange={(e) => setNomeCampagna(e.target.value.toString())} placeholder="Assegna un nome alla campagna" />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={12} className="text-center mt-2">
          <Button className="button position-relative" onClick={addCampagna} disabled={!nomeCampagna || !fileCampagna || loaderUploadActive}>
            Invia <i className="fas fa-chevron-right iconRight"></i>
            <Loader type="upload-file" />
          </Button>
        </Col>
      </Row>

    </div >
  )
}

export default NuovaCampagna;
